import { gql } from '@apollo/client';
import styles from './Video.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function Video({ video, poster, width = undefined, height = undefined, controls = true, autoplay = false, loop =  false, muted = false, playsinline = true }) {
  const videoAttrs = { ...video?.node };
  const posterUrl = poster?.node?.sourceUrl;
  if (!width && !height) {
    width = '100%';
  }
  
	return (
		<video className={cx('video')} width={width} height={height} controls={controls} autoPlay={autoplay} loop={loop} muted={muted} playsInline={playsinline} poster={posterUrl}>
			<source src={videoAttrs.mediaItemUrl} type={videoAttrs.mimeType} />
			Your browser does not support the video tag.
		</video>
	);
}


Video.fragments = {
	entry: gql`
		fragment VideoFragment on AcfMediaItemConnectionEdge {
			node {
				mediaItemUrl
        mimeType
				mediaDetails {
					height
					width
				}
			}
		}
	`,
};
